<template>
			<el-aside
				width="310px"
				style="height: 700px; background-color: #D9D9D9;padding-left:7px;padding-right:7px"
			>
				<div
					style="font-size: 13px; font-weight: bolder; padding-bottom: 20px;padding-top:10px"
				>
					お問い合わせ者リスト

					<el-dropdown
						@command="dropdownSort_phone"
						placement="bottom"
						style="left:95px"
					>
						<span class="el-dropdown-link-phone">
							<span style="color:#9F014E;font-weight: normal;font-size: 13px;">
								{{ this.$store.state.sysInit.dropdownSortTitle }}
							</span>
							<i class="el-icon-caret-bottom"></i>
						</span>
						<el-dropdown-menu
							slot="dropdown"
							style="width:85px;text-align:center"
						>
							<el-dropdown-item command="sortByTime">先着順</el-dropdown-item>
							<el-dropdown-item command="sortBySimilarity"
								>相性順</el-dropdown-item
							>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<div
					style=" width:290px; border-top: 1px solid #7F7F7F;    z-index: 100; "
				></div>
				<el-collapse class="cti_collapse">
					<el-collapse-item name="1">
						<template slot="title">
							<span style="font-size: 12px"
								>担当中の通話({{
									this.$store.state.phone.inCallList.length
								}})</span
							>
						</template>
						<template>
							<ContactInfo
								:callStatus="$store.state.phone.CALL_STATUS_INCALL"
								:callInfoList="$store.state.phone.inCallList"
								@click-one-row="clickOneCall">
							</ContactInfo>
						</template>
					</el-collapse-item>
					<div style=" width:290px; border-top: 1px solid #7F7F7F"></div>
					<el-collapse-item name="2">
						<template slot="title">
							<span style="font-size: 12px"
								>発生中の待ち呼({{
									this.$store.state.phone.waitingList.length
								}})</span
							>
						</template>
						<template>
							<ContactInfo :callStatus="$store.state.phone.CALL_STATUS_WAITING"
								:callInfoList="$store.state.phone.waitingList"
								@click-one-row="clickOneCall">
							</ContactInfo>
						</template>
					</el-collapse-item>
					<!-- <div style="padding:5px;"></div> -->
					<div style=" width:290px; border-top: 1px solid #7F7F7F"></div>

					<el-collapse-item name="3">
						<template slot="title">
							<span style="font-size: 12px"
								>あなたがサポート完了した通話 ({{
									$store.state.sysInit.piRecordInfoObj.piRecordInfo.length
								}})</span
							>
						</template>
						<template>
							<ContactInfo :callStatus="$store.state.phone.CALL_STATUS_END"
								:callInfoList="$store.state.sysInit.piRecordInfoObj.piRecordInfo"
								@click-one-row="clickOneCall">
							</ContactInfo>
						</template>
					</el-collapse-item>
				</el-collapse>
				<!-- </span> -->
			</el-aside>
</template>

<script>
import questioner_logo from '@/assets/img/user_logo.png'
import ContactInfo from "./ContactInfo.vue";
export default {
	components: {ContactInfo},
	data() {
		return {};
	},
	watch: {},
	// computed:{
	// },
	mounted: function() {
		this.$store.state.phone.selectedLine = ''
	},
	beforeDestroy: function() {},
	methods: {
		clickOneCall(userInfo,type){
			let val = userInfo.telnum;
			let telNumVal = userInfo.Tnumber ? userInfo.Tnumber : userInfo.telnum;
			console.log('telNumVal....',telNumVal)
			let PIval = userInfo.Tnumber ? userInfo.Tnumber : userInfo.telnum;
			this.$store.state.store_sv.phone_sv_help_status = (type === this.$store.state.phone.CALL_STATUS_WAITING ?"isWaiting" : (type === this.$store.state.phone.CALL_STATUS_INCALL ? "iscalling" :"isEnd"))
			if(type === this.$store.state.phone.CALL_STATUS_WAITING || type === this.$store.state.phone.CALL_STATUS_INCALL ){
				this.$store.state.phone.selectedLine = val
				this.$store.state.sysInit.searchConditionForm.phone_number = telNumVal;
				this.$store.dispatch("sysInit/searchByCondition", {
					params: this.$store.state.sysInit.searchConditionForm,
				});
			}else{
				this.$store.state.phone.selectedLine = ''
			}
			this.$store.state.sysInit.pi_phone_questioner_logo = userInfo.logo_url && userInfo.logo_url!='' ? userInfo.logo_url : questioner_logo;
			this.$store.dispatch("sysInit/getAllInfoToPi", {
				telNum: PIval,
				excludeIssueId: type === this.$store.state.phone.CALL_STATUS_INCALL ? this.$store.state.phone.redmineIssueId : undefined
			});

			// サマリタブ_直前の応対引継ぎ情報
			// if (type === this.$store.state.phone.CALL_STATUS_WAITING){
			// 	let param = { val: { id: telNumVal }};
			// 	this.$store.dispatch("sysInit/getUC1IssueAllText", param);
			// } else if (type === this.$store.state.phone.CALL_STATUS_INCALL){
			// 	let param = { val: { issue_id: this.$store.state.phone.redmineIssueId ,id: telNumVal }};
			// 	this.$store.dispatch("sysInit/getchatbotAllText", param);
			// } else {
			// 	let param = { val: { issue_id: userInfo.issue_id, id: telNumVal }};
			// 	this.$store.dispatch("sysInit/getchatbotAllText", param);
			// }

			// 応対引継ぎ情報タブ
			if (type === this.$store.state.phone.CALL_STATUS_WAITING){
				let param = {phoneNum: telNumVal };
				this.$store.dispatch("sysInit/getUnsolvedIssueListByPhone", param);
			} else if (type === this.$store.state.phone.CALL_STATUS_INCALL){
				let param = {phoneNum: telNumVal, currentIssueId: this.$store.state.phone.redmineIssueId};
				this.$store.dispatch("sysInit/getUnsolvedIssueListByPhone", param);
			} else {
				let param = {phoneNum: telNumVal, currentIssueId: userInfo.issue_id};
				this.$store.dispatch("sysInit/getUnsolvedIssueListByPhone", param);
			}

			this.$store.state.sysInit.pi_loading = true;
			this.$store.state.sysInit.piIssuesVisible = true;
			this.$store.state.sysInit.piCustomerVisible = true;
			this.$emit('click-one-call',userInfo,type)
		},
		dropdownSort_phone(command) {
			console.log('command.....',command)
			if (command == "sortByTime") {
				this.$store.state.sysInit.phone_WaitingSortByTimeFlg = true;
				// this.$store.state.sysInit.phone_EndingSortByTimeFlg = true;
				this.$store.state.sysInit.dropdownSortTitle = "先着順";
				this.$store.state.phone.callList = _.sortBy( this.$store.state.phone.callList, function(o) { return o.startTime; }).reverse();
			} else {
				//  this.$store.state.sysInit.phone_ChatingSortByTimeFlg = false;
				this.$store.state.sysInit.phone_WaitingSortByTimeFlg = false;
				// this.$store.state.sysInit.phone_EndingSortByTimeFlg = false;
				this.$store.state.sysInit.dropdownSortTitle = "相性順";
				this.$store.state.phone.callList = _.orderBy(this.$store.state.phone.callList,['similarity'],['desc']);
			}
	  },
	},
};
</script>
<style lang="scss" scoped>
.el-dropdown-link-phone {
	cursor: pointer;
	color: #9F014E;
	background-color: #FAD0E4;
	border: 1px solid #FF9BCC;
	padding: 2px 3px;
	border-radius: 5px;
}
.el-dropdown-menu__item:hover {
  background-color: #FAD0E4;
  color: #9F014E;
}
</style>
